import { render } from "./LifePaymentCompleted.vue?vue&type=template&id=7da50e3c"
import script from "./LifePaymentCompleted.vue?vue&type=script&lang=js"
export * from "./LifePaymentCompleted.vue?vue&type=script&lang=js"

import "./LifePaymentCompleted.vue?vue&type=style&index=0&id=7da50e3c&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__